import { StateOfGoods } from "@freightsimple/generated-dashboard-openapi-client/models/StateOfGoods";
import type { ReactNode } from "react";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { T } from "@freightsimple/ui-core/Typography/T";
import { NewIcon, StateOfGoodsIcons } from "@/Shared/Icons/StateOfGoodsIcons";

export function getStateOfGoodsText(stateOfGoods: StateOfGoods): ReactNode {
  switch (stateOfGoods) {
    case StateOfGoods.New:
      return (
        <Row gap={1}>
          <NewIcon />
          <T color="muted">New</T>
        </Row>
      );
    case StateOfGoods.Used:
      return (
        <Row gap={1}>
          <StateOfGoodsIcons />
          <T color="muted">Used</T>
        </Row>
      );
  }
}
